(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hobbyverf-3d-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const COLOR_RULES = [
      [/rose gold/i, '#c98a86'],
      [/black|zwart|obsidian|black sequins/i, '#29272c'],
      [/white|wit|pearl|clear ice/i, '#e7e4de'],
      [/silver|zilver|platinum/i, '#bfc5cc'],
      [/champagne|gold|goud|harvest gold|glorious gold/i, '#d2a646'],
      [/fuchsia|magenta|baby pink|pink|rose|sugar plum|dark rose/i, '#d6619b'],
      [/burgundy|bordeaux|red|rood|pepper|flame|santa red/i, '#b94750'],
      [/orange|oranje/i, '#e98037'],
      [/yellow|geel/i, '#e5c63f'],
      [/emerald|avocado|jade|olive|green|groen/i, '#5b9769'],
      [/turquoise|turkis|aqua|teal/i, '#43a7aa'],
      [/sapphire|ocean blue|midnight blue|eisblau|blue|blauw/i, '#4d76c7'],
      [/dioxazine|amethyst|violet|violett|purple|paars|lavender/i, '#7f5bb1'],
      [/brown|bruin|kakao|cappuccino/i, '#8e6d55']
    ];

    const inferColor = (title, fallback) => {
      for (const [pattern, color] of COLOR_RULES) {
        if (pattern.test(title)) return color;
      }
      return fallback;
    };

    const initShowcase = (root) => {
      if (!root || root.dataset.initialized === 'true') return;

      const items = [...root.querySelectorAll('.paint-showcase__item')];
      if (!items.length) return;

      const stage = root.querySelector('[data-stage]');
      const prev = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');
      const title = root.querySelector('[data-detail-title]');
      const vendor = root.querySelector('[data-detail-vendor]');
      const price = root.querySelector('[data-detail-price]');
      const link = root.querySelector('[data-product-link]');
      const current = root.querySelector('[data-current]');
      const total = root.querySelector('[data-total]');
      const fallbackColor = root.dataset.fallbackColor || '#d9c8bf';
      const autoRotate = root.dataset.autoRotate === 'true';
      const autoSeconds = Math.max(3, Number(root.dataset.autoSeconds) || 5);

      let active = 0;
      let timer = null;
      let pointerStart = null;
      let suppressClick = false;

      const wrappedOffset = (index) => {
        let offset = index - active;
        const half = items.length / 2;
        if (offset > half) offset -= items.length;
        if (offset < -half) offset += items.length;
        return offset;
      };

      const stepSize = () => {
        const width = stage ? stage.clientWidth : window.innerWidth;
        return window.matchMedia('(max-width: 749px)').matches
          ? Math.min(108, width * 0.285)
          : Math.min(215, width * 0.19);
      };

      const render = () => {
        const step = stepSize();

        items.forEach((item, index) => {
          const offset = wrappedOffset(index);
          const distance = Math.abs(offset);
          const visible = distance <= 3;
          const scale = distance === 0 ? 1.12 : Math.max(0.56, 0.92 - distance * 0.13);
          const opacity = visible ? Math.max(0.18, 1 - distance * 0.23) : 0;
          const rotate = Math.max(-42, Math.min(42, offset * -16));
          const blur = distance >= 3 ? 1.5 : 0;

          item.style.setProperty('--x', `${offset * step}px`);
          item.style.setProperty('--scale', scale.toFixed(3));
          item.style.setProperty('--rotate', `${rotate}deg`);
          item.style.setProperty('--item-opacity', opacity.toFixed(3));
          item.style.setProperty('--blur', `${blur}px`);
          item.style.zIndex = String(20 - Math.round(distance));
          item.classList.toggle('is-active', index === active);
          item.setAttribute('aria-current', index === active ? 'true' : 'false');
          item.tabIndex = index === active ? 0 : -1;
          item.style.pointerEvents = visible ? 'auto' : 'none';
        });

        const selected = items[active];
        const selectedTitle = selected.dataset.title || '';
        const selectedColor = selected.dataset.color || inferColor(selectedTitle, fallbackColor);

        root.style.setProperty('--active-color', selectedColor);
        if (title) title.textContent = selectedTitle;
        if (vendor) vendor.textContent = selected.dataset.vendor || '';
        if (price) price.textContent = selected.dataset.price || '';
        if (link) link.href = selected.dataset.url || '#';
        if (current) current.textContent = String(active + 1);
        if (total) total.textContent = String(items.length);
      };

      const select = (index, restart = true) => {
        active = (index + items.length) % items.length;
        render();
        if (restart) restartAuto();
      };

      const stopAuto = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const startAuto = () => {
        if (!autoRotate || items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        stopAuto();
        timer = window.setInterval(() => select(active + 1, false), autoSeconds * 1000);
      };

      const restartAuto = () => {
        stopAuto();
        startAuto();
      };

      items.forEach((item, index) => {
        item.addEventListener('click', (event) => {
          if (suppressClick) {
            event.preventDefault();
            return;
          }

          if (index !== active) {
            event.preventDefault();
            select(index);
          }
        });
      });

      prev?.addEventListener('click', () => select(active - 1));
      next?.addEventListener('click', () => select(active + 1));

      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          select(active - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          select(active + 1);
        }
      });

      stage?.addEventListener('pointerdown', (event) => {
        pointerStart = event.clientX;
        stopAuto();
      });

      stage?.addEventListener('pointerup', (event) => {
        if (pointerStart === null) return;
        const delta = event.clientX - pointerStart;
        pointerStart = null;

        if (Math.abs(delta) > 34) {
          suppressClick = true;
          select(active + (delta < 0 ? 1 : -1));
          window.setTimeout(() => { suppressClick = false; }, 0);
        } else {
          startAuto();
        }
      });

      stage?.addEventListener('pointercancel', () => {
        pointerStart = null;
        startAuto();
      });

      root.addEventListener('mouseenter', stopAuto);
      root.addEventListener('mouseleave', startAuto);
      root.addEventListener('focusin', stopAuto);
      root.addEventListener('focusout', startAuto);

      let resizeFrame = null;
      window.addEventListener('resize', () => {
        if (resizeFrame) cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(render);
      });

      root.dataset.initialized = 'true';
      root.classList.add('is-enhanced');
      render();
      startAuto();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-paint-showcase]').forEach(initShowcase);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
